import React, { useEffect } from "react";
import { Subheadline } from "@quintype/arrow";
import get from "lodash/get";
import { object, bool } from "prop-types";
import HeroImage from "./hero-image";
import AuthorAndTimeStamp from "./author-and-timestamp";
import PodcastCard from "../story-header/podcast-card";
import SponsoredTag from "../../atoms/sponsored-tag";
import { AdContainer } from "../../ads";

import "./story-header.m.css";

import useAdType from "../../helper/custom-hook/useAdType";
import useDevice from "../../helper/custom-hook/useDevice";

const StoryHeader = ({ story, isPodCast, showHeroImage, isSponsoredStory, isLiveBlog }) => {
  const isClosed = get(story, ["metadata", "is-closed"], false);
  const adType = useAdType();
  const isMobile = useDevice();
  const tags = story.tags || [];
  const isPremiumStory = tags.some(tag => tag.name === "premium" || tag.name === "Premium");

  useEffect(() => {
    _izq.push(["getNotificationFeed", function (response) { }]);
  }, []);

  const heroImageMinHeight = isMobile ? "184px" : "456px";

  return (
    <div styleName="wrapper">
      {isPremiumStory && <div styleName="premiumBadge">
        <img
          src="https://thumbor-stg.assettype.com/prajavani2/2026-05-26/vz8c16hs/Small.svg"
          alt="Premium"
          styleName="premiumBadgeIcon"
        />
        <span styleName="premiumBadgeText">ಪ್ರೀಮಿಯಂ</span>
      </div>}
      {isPodCast && <PodcastCard story={story} />}
      {isSponsoredStory && <SponsoredTag />}

      <div styleName={isLiveBlog ? "live-blog-header-h1-wrapper" : "header-h1-wrapper"}>
        <h1>
          {story.headline}
          {isLiveBlog && !isClosed && (
            <div styleName="live-btn-wrapper">
              <div styleName="live-btn">
                <div styleName="oval"></div>
                <span>LIVE</span>
              </div>
            </div>
          )}
        </h1>
      </div>
      <Subheadline lineClamp={10} story={story} clazzName="sub-headline" />
      <div className="author-resizer-wrapper" id="author-resizer-wrapper">
        <AuthorAndTimeStamp story={story} />
      </div>
      <div
        style={{
          minHeight: showHeroImage ? heroImageMinHeight : "0px",
          transition: "min-height 0.3s ease",
          overflow: "hidden"
        }}
      >
        {showHeroImage ? <HeroImage story={story} /> : null}
      </div>
    </div>
  );
};

StoryHeader.propTypes = {
  story: object,
  isPodCast: bool,
  showHeroImage: bool,
  isSponsoredStory: bool,
  isLiveBlog: bool
};
StoryHeader.defaultProps = {
  isPodcast: false,
  isSponsoredStory: false,
  showHeroImage: true,
  isLiveBlog: false
};

export default StoryHeader;
